import { useContext } from 'react';
import PortfolioItemContext from '@/components/ChallengePortfolio/NormalView/portfolio-item/PortfolioItemContext';
import useApi from '@/lib/api/useApi';
import {
  type SetComplexImmerStateAction,
  type Task,
  type TaskSummary,
  type UserSummary,
} from '@/lib/types';

const useRemoveAssignee = (): ((user: UserSummary) => Promise<void>) => {
  const api = useApi();

  const {
    setPortfolioItem: setTask,
    setPortfolioItemSummary: setTaskSummary,
    portfolioItemApiEndpoint: taskApiEndpoint,
  } = useContext(PortfolioItemContext) as {
    setPortfolioItem: SetComplexImmerStateAction<Task>;
    setPortfolioItemSummary: SetComplexImmerStateAction<TaskSummary>;
    portfolioItemApiEndpoint: string;
  };

  const removeAssignee = async (user: UserSummary): Promise<void> => {
    await api.post(`${taskApiEndpoint}/assignees/remove`, {
      email: user.email,
    });

    setTask(task => {
      task.assigneesCount--;
      task.assignees.splice(
        task.assignees.findIndex(assignee => assignee.email === user.email),
        1,
      );
    });

    setTaskSummary(taskSummary => {
      taskSummary.assignees.splice(
        taskSummary.assignees.findIndex(
          assignee => assignee.email === user.email,
        ),
        1,
      );
    });
  };

  return removeAssignee;
};

export default useRemoveAssignee;
